import Status from "../ValueObject/Status";
import DocumentRepository from "../Repository/DocumentRepository";
import Document from "../Entity/Document";

export default class ChangeDocumentStatus {
    public constructor(
        private readonly documentRepository: DocumentRepository
    ) {
    }

    public change(id: string, status: Status): void {
        const document: Document | null = this.documentRepository.getById(id);
        if (null === document) {
            return;
        }

        document.setStatus(status);
        this.documentRepository.save(document);
    }
}